import type { RouteObject } from 'react-router-dom';
import { crudRoute } from '@shared/crud/crud-route';

/** People master data (people-service). Leave types are under Leave. */
export const organizationRoutes: RouteObject[] = [
  crudRoute(
    'organization/departments',
    'departments',
    async () => (await import('./departments/config')).departmentConfig,
  ),
  crudRoute('organization/teams', 'teams', async () => (await import('./teams/config')).teamConfig),
  crudRoute(
    'organization/designations',
    'designations',
    async () => (await import('./designations/config')).designationConfig,
  ),
  crudRoute(
    'organization/skills',
    'skills',
    async () => (await import('./skills/config')).skillConfig,
  ),
  crudRoute(
    'organization/employment-types',
    'employment-types',
    async () => (await import('./employment-types/config')).employmentTypeConfig,
  ),
  crudRoute(
    'organization/salary-types',
    'salary-types',
    async () => (await import('./salary-types/config')).salaryTypeConfig,
  ),
  crudRoute(
    'organization/employee-status',
    'employee-statuses',
    async () => (await import('./employee-status/config')).employeeStatusConfig,
  ),
];

export { crudRoute };
